let items_map = document.querySelectorAll('.js-item-map');
items_map.forEach(item_map => {
	item_map.addEventListener('click', handleClick);
	let mapTooltip = document.getElementById('map-tooltip');
	let mapWrapper = document.getElementById('map-wrapper');

	item_map.addEventListener('mouseenter', function (e) {
		let state = item_map.dataset.state;
		mapTooltip.classList.add('tooltip-show');
		mapTooltip.innerHTML = state;
	});
	mapWrapper.addEventListener('mouseleave', function () {
		mapTooltip.classList.remove('tooltip-show');
	});
});

function handleClick(e) {
	let contentMap = document.getElementById('map-content');
	let contentImage = document.getElementById('map-image-embed');
	contentMap.style.display = "block";
	contentImage.classList.add('active');
	// List
	let items_map = document.querySelectorAll('.js-item-map');
	items_map.forEach(item_map => {
		item_map.classList.remove('active');
	});
	// Hover
	if (e.target.classList.contains('enable')) {
		e.target.classList.add('active');
	}else{
		let items_map_sub = document.querySelectorAll('.js-item-map');
		items_map_sub.forEach(item_map_sub => {
			if (item_map_sub.classList.contains('enable')) {
				item_map_sub.classList.add('active');
			}
		});
		let contentImage = document.getElementById('map-image-embed');
			contentImage.classList.remove('active');
	}
	// Data
	const state = e.target.dataset.state;
	const descripcion = e.target.dataset.descripcion;
	const list = e.target.dataset.list;
	// Content HTML
	let contentState = document.getElementById('map-state');
	let contentDescription = document.getElementById('map-description');
	let contentMunicipality = document.getElementById('map-municipality');
	let contentList = document.getElementById('map-list');
	// Set value into HTML
	let valueState = (state != undefined) ? state : '';
	contentState.innerHTML = valueState;
	let valueDescription = (descripcion != undefined) ? descripcion : 'No tenemos cobertura en este estado pero estamos trabajando para llegar más lejos sin embargo podemos hacer llegar tu pedido con una paquetería externa.';
	contentDescription.innerHTML = valueDescription;
	let valueList = (list != undefined) ? list : '';
	contentList.innerHTML = valueList;
	// Show title
	let regex = /[^\s]/;
	let iCondicion = regex.test(list);
	if (list != undefined && iCondicion == true) {
		contentMunicipality.style.display = "block";
	}else{
		contentMunicipality.style.display = "none";
	}
}

const myDiv = document.getElementById('map-wrapper');
const cursorFollower = document.getElementById('map-tooltip');

myDiv.addEventListener('mousemove', function(event) {
  const divRect = myDiv.getBoundingClientRect();
  const x = event.clientX - divRect.left;
  const y = event.clientY - divRect.top;
  
  cursorFollower.style.left = x + 'px';
  cursorFollower.style.top = y + 'px';
});